var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.152,
    height: 20.152,
    viewBox: "0 0 20.152 20.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17137",
    "data-name": "Group 17137",
    transform: "translate(15064 3571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone-call",
    transform: "translate(-15062 -3569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15805",
    "data-name": "Group 15805",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8009",
    "data-name": "Path 8009",
    d: "M15.584,11.363,13.424,9.2a1.437,1.437,0,0,0-2.392.54,1.47,1.47,0,0,1-1.7.926A6.663,6.663,0,0,1,5.321,6.656a1.4,1.4,0,0,1,.926-1.7,1.437,1.437,0,0,0,.54-2.392L4.627.405a1.541,1.541,0,0,0-2.083,0L1.077,1.871c-1.466,1.543.154,5.633,3.781,9.26s7.717,5.325,9.26,3.781l1.466-1.466A1.541,1.541,0,0,0,15.584,11.363Z",
    transform: "translate(-0.539 0)",
    fill: "#3f2566"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2058",
    "data-name": "Rectangle 2058",
    width: 20.152,
    height: 20.152,
    transform: "translate(-15064 -3571)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a8b540482977fd96fa38dadb3ad2f44d.svg";
export { ForwardRef as ReactComponent };